// extracted by mini-css-extract-plugin
module.exports = {"Flex":"Reason_Flex__ISweh"};